import { PencilIcon, ClockIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { UploadedReceipt } from '../../../types';
import { getFormattedTime } from '../utils/timeUtils';

import ImportStatusSummary from './ImportStatusSummary';

interface ImportDetailsHeaderDisplayProps {
  title?: string;
  description?: string;
  createdAt: string;
  updatedAt: string;
  receipts: UploadedReceipt[];
  onEdit: () => void;
}

const ImportDetailsHeaderDisplay: React.FC<
  ImportDetailsHeaderDisplayProps
> = ({ title, description, createdAt, updatedAt, receipts, onEdit }) => {
  const displayTitle =
    title?.trim() || `Untitled import - ${getFormattedTime(createdAt)}`;

  return (
    <div>
      {/* Header with Edit Button */}
      <div className='flex items-start justify-between mb-4'>
        <div className='flex-1'>
          <h1 className='text-3xl font-bold text-gray-900 dark:text-gray-50 mb-2'>
            {displayTitle}
          </h1>
          {description?.trim() && (
            <p className='text-gray-600 dark:text-gray-400'>{description}</p>
          )}
        </div>
        <button
          onClick={onEdit}
          className='p-2 text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors duration-200'
          title='Edit import details'
        >
          <PencilIcon className='w-5 h-5' />
        </button>
      </div>

      {/* Timestamps */}
      <div className='flex items-center space-x-4 text-sm text-gray-500 dark:text-gray-400'>
        <div className='flex items-center'>
          <ClockIcon className='w-4 h-4 mr-1' />
          <span>Created: {getFormattedTime(createdAt)}</span>
        </div>
        {createdAt !== updatedAt && (
          <div className='flex items-center'>
            <ClockIcon className='w-4 h-4 mr-1' />
            <span>Updated: {getFormattedTime(updatedAt)}</span>
          </div>
        )}
      </div>

      {/* Status Summary */}
      <div className='mt-6'>
        <ImportStatusSummary receipts={receipts} />
      </div>
    </div>
  );
};

export default ImportDetailsHeaderDisplay;
